import React from 'react';
import { bool, func } from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import { LaunchRounded } from '@mui/icons-material';

import { Section } from '../../styles';
import staticText from '../../../../../../localization/Application/Billing/addOns';
import spinningButtonStyles from '../../../../../../global-styles/animations/spinningButton';
import { Chip, InlineLinks } from '../../../../../../components';

/**
 *** THIS COMPONENT IS NOT CURRENTLY BEING USED (AWAITING ADD-ON FUNCTIONALITY) ***
 *** AND WILL NEED TO BE UPDATED WHEN ADD-ON FUNCTIONALITY IS ADDED ***
 *** FOR NOW, IT IS DISPLAYING ONE ADD-ON WITH NO FUNCTIONALITY ***
 */
const AddOns = ({
  buttonOnClick,
  buttonIconEnabled,
  isButtonLoading,
}) => {
  return (
    <Section>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" gap={1} alignItems="center">
            <Typography variant="h2">
              {staticText.compatibilityApi.heading}
            </Typography>
            <Chip label={staticText.status.enabled} type="success" />
          </Box>
          <Typography variant="body2" color="text.secondary">
            <InlineLinks text={staticText.compatibilityApi.description} />
          </Typography>
        </Box>

        <Button
          onClick={buttonOnClick}
          variant="outlined"
          endIcon={buttonIconEnabled ?
            <LaunchRounded fontSize="inherit" /> :
          null}
          sx={isButtonLoading && spinningButtonStyles}
        >
          {staticText.actions.enable}
        </Button>
      </Box>
    </Section>
  );
};

export default AddOns;

AddOns.propTypes = {
  buttonOnClick: func,
  buttonIconEnabled: bool,
  isButtonLoading: bool,
};

AddOns.defaultProps = {
  buttonOnClick: null,
  buttonIconEnabled: false,
  isButtonLoading: false,
};
